import moment from 'moment';
import momentTz from 'moment-timezone';

import type { NSchedule } from '@app/types';

import {
  RECORD_MINUTES_SMALLEST_STEP,
  RECORD_MINUTES_SMALLEST_STEP_PIXELS,
} from '../constants';

export const calculateTopForCurrentTimeFromStartOfDay = (
  currentTime: string,
  startOfDay: string,
  branchTimezone?: NSchedule.ModelBranchWorkTime['Timezone']
) => {
  const startTime = branchTimezone
    ? momentTz(currentTime).tz(branchTimezone)
    : moment(currentTime);
  const duration = moment.duration(startTime.diff(startOfDay));
  const minutes = duration.asMinutes();
  const top =
    (minutes / RECORD_MINUTES_SMALLEST_STEP) *
    RECORD_MINUTES_SMALLEST_STEP_PIXELS;

  return top;
};
